"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var JackpotEditor = /** @class */ (function (_super) {
    __extends(JackpotEditor, _super);
    function JackpotEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.EMAIL_TYPE_CODE_JACKPOT = 5;
        _this.MESSAGE_TYPE_CODE_JACKPOT = 3;
        return _this;
    }
    JackpotEditor.prototype.getJpIncPercentAvail = function () {
        var _ret = [];
        _ret.push({ key: 1, value: "0.01 %" });
        _ret.push({ key: 2, value: "0.02 %" });
        _ret.push({ key: 3, value: "0.05 %" });
        _ret.push({ key: 4, value: "0.1 %" });
        _ret.push({ key: 5, value: "0.2 %" });
        _ret.push({ key: 6, value: "0.5 %" });
        _ret.push({ key: 7, value: "1 %" });
        return _ret;
    };
    JackpotEditor.prototype.getIncIdxByVal = function (val) {
        var _Idx = 0;
        if (val === 0.01) {
            _Idx = 1;
        }
        if (val === 0.02) {
            _Idx = 2;
        }
        if (val === 0.05) {
            _Idx = 3;
        }
        if (val === 0.1) {
            _Idx = 4;
        }
        if (val === 0.2) {
            _Idx = 5;
        }
        if (val === 0.5) {
            _Idx = 6;
        }
        if (val === 1) {
            _Idx = 7;
        }
        return _Idx;
    };
    JackpotEditor.prototype.getIncValByIdx = function (idx) {
        var _Val = 0;
        if (idx === 1) {
            _Val = 0.01;
        }
        if (idx === 2) {
            _Val = 0.02;
        }
        if (idx === 3) {
            _Val = 0.05;
        }
        if (idx === 4) {
            _Val = 0.1;
        }
        if (idx === 5) {
            _Val = 0.2;
        }
        if (idx === 6) {
            _Val = 0.5;
        }
        if (idx === 7) {
            _Val = 1;
        }
        return _Val;
    };
    JackpotEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_LBP = this.props.listBonusPermissionTypes.Subscribe("*", function (id, data) {
            _this.setState({
                _bonus_permissions: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    description: _item.description,
                    is_locked: _item.is_locked,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    jp_tag: _item.jp_tag,
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    jp_amount_to_trigger: _item.jp_amount_to_trigger,
                    jp_inc_percent: _item.jp_inc_percent,
                    jp_inc_percent_avail: this.getJpIncPercentAvail(),
                    jp_inc_percent_title: _item.jp_inc_percent + " %",
                    jp_min_amount_to_win: _item.jp_min_amount_to_win,
                    jp_max_amount_to_win: _item.jp_max_amount_to_win,
                    //is_can_interact_with_all_currency: _item.is_can_interact_with_all_currency,
                    jp_can_trigger_check_interval_min: _item.jp_can_trigger_check_interval_min,
                    tabKey: this.key_main,
                    css_classname: _item.jp_css_classname,
                    _bonus_permissions: [],
                    jp_min_view_win_amount: _item.jp_min_view_win_amt,
                    jp_max_view_win_amount: _item.jp_max_view_win_amt
                    // is_send_to_all_players_jackpot_win_message: _item.is_send_to_all_players_jackpot_win_message
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование джекпота"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                description: "",
                is_locked: false,
                brand_id: 0,
                brand_title: "",
                jp_tag: "",
                app_currency_id: 0,
                app_currency_title: "",
                jp_min_amount_to_win: 100,
                jp_max_amount_to_win: 200,
                jp_amount_to_trigger: 0,
                jp_inc_percent: this.getJpIncPercentAvail()[0].key,
                jp_inc_percent_avail: this.getJpIncPercentAvail(),
                jp_inc_percent_title: this.getJpIncPercentAvail()[0].value,
                jp_can_trigger_check_interval_min: 60,
                // is_can_interact_with_all_currency: false,
                tabKey: this.key_main,
                _bonus_permissions: [],
                css_classname: "",
                jp_min_view_win_amount: 0.01,
                jp_max_view_win_amount: 1
                // is_send_to_all_players_jackpot_win_message: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание джекпота"]);
            });
        }
        this.props.listBonusPermissionTypes.LoadData();
        this.doReSetRules();
    };
    JackpotEditor.prototype.componentWillUnmount = function () {
        this.props.listBonusPermissionTypes.UnSubscribe(this.SID_LBP);
    };
    JackpotEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            jp_tag_rules: { isError: false },
            brand_rules: { isError: false },
            jp_inc_percent_rules: { isError: false },
            app_currency_rules: { isError: false },
            jp_min_amount_to_win_rules: { isError: false },
            jp_can_trigger_check_interval_min_rules: { isError: false },
            jp_max_amount_to_win_rules: { isError: false },
            jp_amount_to_trigger_rules: { isError: false },
            jp_min_view_win_amount_rules: { isError: false },
            jp_max_view_win_amount_rules: { isError: false }
        });
    };
    JackpotEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.jp_tag) || (this.state.jp_tag.length === 0)) {
            this.setState({
                jp_tag_rules: { isError: true, errorMessage: "Поле [тэг джекпота] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({
                app_currency_rules: { isError: true, errorMessage: "Поле [валюта] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.jp_inc_percent <= 0) || (this.state.jp_inc_percent_title.length === 0)) {
            this.setState({
                jp_inc_percent_rules: { isError: true, errorMessage: "Поле [процент отчисления] не выбрано!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.jp_min_amount_to_win <= 0) {
            this.setState({
                jp_min_amount_to_win_rules: { isError: true, errorMessage: "Поле [минимальная сумма выигрыша] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.jp_max_amount_to_win <= 0) {
            this.setState({
                jp_max_amount_to_win_rules: { isError: true, errorMessage: "Поле [максимальная сумма выигрыша] не заполнена!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.jp_max_amount_to_win <= this.state.jp_min_amount_to_win) {
            this.setState({
                jp_min_amount_to_win_rules: { isError: true, errorMessage: "Поле [минимальная сумма выигрыша] заполнена некорректно!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if (!this.state.jp_amount_to_trigger) {
            this.setState({
                jp_amount_to_trigger_rules: { isError: true, errorMessage: "Поле [сумма срабатывания] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.jp_amount_to_trigger <= 0) {
            this.setState({
                jp_amount_to_trigger_rules: { isError: true, errorMessage: "Поле [сумма срабатывания] имеет некорректное значение!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if (!this.state.jp_min_view_win_amount) {
            this.setState({
                jp_min_view_win_amount_rules: { isError: true, errorMessage: "Поле [мин сумма увеличения] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if (!this.state.jp_max_view_win_amount) {
            this.setState({
                jp_max_view_win_amount_rules: { isError: true, errorMessage: "Поле [макс сумма увеличения] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        return true;
    };
    JackpotEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                description: this.state.description,
                is_locked: this.state.is_locked,
                jp_amount_to_trigger: this.state.jp_amount_to_trigger,
                jp_inc_percent: this.state.jp_inc_percent,
                jp_tag: this.state.jp_tag,
                jp_min_amount_to_win: this.state.jp_min_amount_to_win,
                title: this.state.title,
                jp_max_amount_to_win: this.state.jp_max_amount_to_win,
                jp_can_trigger_check_interval_min: this.state.jp_can_trigger_check_interval_min,
                jp_css_classname: this.state.css_classname,
                jp_min_view_win_amt: this.state.jp_min_view_win_amount,
                jp_max_view_win_amt: this.state.jp_max_view_win_amount
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Джекпот изменен!");
            });
        }
    };
    JackpotEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                description: this.state.description,
                app_currency_id: this.state.app_currency_id,
                brand_id: this.state.brand_id,
                is_locked: this.state.is_locked,
                jp_amount_to_trigger: this.state.jp_amount_to_trigger,
                jp_inc_percent: this.state.jp_inc_percent,
                jp_tag: this.state.jp_tag,
                jp_min_amount_to_win: this.state.jp_min_amount_to_win,
                title: this.state.title,
                jp_max_amount_to_win: this.state.jp_max_amount_to_win,
                jp_can_trigger_check_interval_min: this.state.jp_can_trigger_check_interval_min,
                jp_css_classname: this.state.css_classname,
                jp_min_view_win_amt: this.state.jp_min_view_win_amount,
                jp_max_view_win_amt: this.state.jp_max_view_win_amount
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Джекпот добавлен!");
            });
        }
    };
    JackpotEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    JackpotEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить джекпот";
        }
        else {
            return "Изменить джекпот";
        }
    };
    JackpotEditor.prototype.getActionButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    JackpotEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тэг джекпота:", placeholder: "Введите тэг джекпота" }, value: this.state.jp_tag, onValueChanged: function (newVal) { _this.setState({ jp_tag: newVal }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд :", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.brandsAvail, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта :", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.appCurrencyAvail, disabled: this.props.record != null, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Комментарий:", placeholder: "Введите комментарий" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "CSS класс:", placeholder: "Введите css класс джекпота" }, value: this.state.css_classname, onValueChanged: function (newVal) { _this.setState({ css_classname: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Джекпот заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            this.getActionButtons()));
    };
    JackpotEditor.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин сумма отображения", placeholder: "Введите минимальную сумму увеличения отображения" }, values: { max: 999, min: 0.01, value: this.state.jp_min_view_win_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        jp_min_view_win_amount: newVal,
                        jp_min_view_win_amount_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.jp_min_view_win_amount_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма отображения", placeholder: "Введите максимальную сумму увеличения отображения" }, values: { max: 999, min: 0.01, value: this.state.jp_max_view_win_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        jp_max_view_win_amount: newVal,
                        jp_max_view_win_amount_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.jp_max_view_win_amount_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "% отчислений", placeholder: "Выберите % отчислений в джекпот" }, value: { key: this.getIncIdxByVal(this.state.jp_inc_percent), value: this.state.jp_inc_percent_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        jp_inc_percent: _this.getIncValByIdx(newVal.key),
                        jp_inc_percent_title: newVal.value,
                        jp_inc_percent_rules: { isError: false }
                    });
                }, items: this.state.jp_inc_percent_avail, required: true, rules: this.state.jp_inc_percent_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма срабатывания", placeholder: "Введите сумму срабатывания" }, values: { max: 99999999999, min: 1, value: this.state.jp_amount_to_trigger }, onValueChanged: function (newVal) {
                    _this.setState({
                        jp_amount_to_trigger: newVal,
                        jp_amount_to_trigger_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.jp_amount_to_trigger_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин сумма выигрыша", placeholder: "Введите минимальную сумму выигрыша" }, values: { max: 99999999999, min: 1, value: this.state.jp_min_amount_to_win }, onValueChanged: function (newVal) {
                    _this.setState({
                        jp_min_amount_to_win: newVal,
                        jp_min_amount_to_win_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.jp_min_amount_to_win_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма выигрыша", placeholder: "Введите максимальную сумму выигрыша" }, values: { max: 99999999999, min: 1, value: this.state.jp_max_amount_to_win }, onValueChanged: function (newVal) {
                    _this.setState({
                        jp_max_amount_to_win: newVal,
                        jp_max_amount_to_win_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.jp_max_amount_to_win_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Интервал проверки, мин", placeholder: "Введите интервал проверки джекпота" }, values: { max: 99999999999, min: 1, value: this.state.jp_can_trigger_check_interval_min }, onValueChanged: function (newVal) {
                    _this.setState({
                        jp_can_trigger_check_interval_min: newVal,
                        jp_can_trigger_check_interval_min_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.jp_can_trigger_check_interval_min_rules }),
            this.getActionButtons()));
    };
    JackpotEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        return null;
    };
    JackpotEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" },
            ], onTabChange: function (key) { _this.setState({ tabKey: key }); } }, this.getContent()));
    };
    return JackpotEditor;
}(React.Component));
exports.default = JackpotEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ui/component/JackpotEditor.tsx
// module id = 2341
// module chunks = 0